import { type FC } from "react";

import { type ValuePathComponent, type ValuePathRoot } from "../traverseValue/ValuePath";
import { stringifyValueName } from "./stringifyValueName";

export const CollapsedValueName: FC<{ component: ValuePathRoot | ValuePathComponent }> = ({
	component,
}) => {
	const name = stringifyValueName(component);
	return <span className="text-syntax-key px-1">{name}</span>;
};
